import React from "react"
import ReactDOM from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"
import "@warpme/i18n"
import { Provider as UrqlProvider } from "urql"
import { Toaster } from "@/components/ui/toaster"
import { CurrentUserProvider } from "@/lib/CurrentUserProvider"
import { auth } from "@/lib/firebase"
import { createUrqlClient } from "@/lib/urql"
import { Routes } from "./router"
import "./globals.css"

type AppUrqlProviderProps = {
  children: React.ReactNode
}

const AppUrqlProvider = ({ children }: AppUrqlProviderProps) => {
  const [client, setClient] = React.useState(() => createUrqlClient())
  const previousUserIdRef = React.useRef(auth.currentUser()?.uid ?? null)

  React.useEffect(
    () =>
      auth.onAuthStateChanged((authUser) => {
        const nextUserId = authUser?.uid ?? null
        if (previousUserIdRef.current === nextUserId) return

        previousUserIdRef.current = nextUserId
        setClient(createUrqlClient())
      }),
    []
  )

  return <UrqlProvider value={client}>{children}</UrqlProvider>
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <CurrentUserProvider>
        <AppUrqlProvider>
          <Routes />
        </AppUrqlProvider>
      </CurrentUserProvider>
    </HelmetProvider>
    <Toaster />
  </React.StrictMode>
)
